var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-522 -377)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.875 15.03C14.0769 14.8205 14.1898 14.541 14.19 14.25 14.1912 13.9544 14.0737 13.6706 13.8638 13.4625L10.3088 9.90375C10.0989 9.69364 9.81446 9.57499 9.5175 9.57375 9.22185 9.576 8.93895 9.69454 8.73 9.90375L8.33625 10.3012 13.4662 15.42Z",
    fill: "#4C39A0",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.02778 0 0 1 523 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 24.135C18.8163 24.3535 18.4649 24.3564 18.2464 24.1414 18.2442 24.1393 18.2421 24.1371 18.24 24.135L11.865 17.76C11.6457 17.5404 11.6457 17.1846 11.865 16.965L12.66 16.1925 7.54875 11.085C7.21875 11.415 6.89625 11.7375 6.68625 11.9362 6.17194 12.4169 5.8641 13.0783 5.8275 13.7812 5.78111 14.9279 5.9859 16.0708 6.4275 17.13 6.85065 18.0791 7.36958 18.9825 7.97625 19.8263 10.0861 22.9917 12.7546 25.7466 15.8512 27.9563 16.3683 28.3387 16.9122 28.6833 17.4788 28.9875 18.7592 29.6605 20.1621 30.0686 21.6038 30.1875 22.5898 30.2592 23.5552 29.88 24.2288 29.1562L24.9338 28.4513 19.8038 23.34Z",
    fill: "#4C39A0",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.02778 0 0 1 523 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1112 25.6912 22.5563 22.125C22.1179 21.6913 21.4121 21.6913 20.9738 22.125L20.5988 22.53 25.7137 27.6675 26.1112 27.2925C26.545 26.8542 26.545 26.1483 26.1112 25.71Z",
    fill: "#4C39A0",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.02778 0 0 1 523 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3025 18.75 21.8025 18.75C21.6399 16.5987 20.1007 14.8015 18 14.31L18 12.78C20.9349 13.3053 23.1273 15.7736 23.3025 18.75Z",
    fill: "#4C39A0",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.02778 0 0 1 523 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8875 18C26.8875 18.2512 26.8875 18.5025 26.8538 18.75L25.3538 18.75C25.3795 18.5009 25.392 18.2505 25.3913 18 25.3851 13.9211 22.0789 10.6166 18 10.6125L18 9.1125C22.9067 9.11662 26.8834 13.0933 26.8875 18Z",
    fill: "#4C39A0",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.02778 0 0 1 523 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.75 18C30.75 18.2512 30.75 18.5025 30.7238 18.75L29.2238 18.75C29.2238 18.5025 29.2537 18.2512 29.2537 18 29.2537 11.9939 24.3849 7.125 18.3787 7.125 18.3775 7.125 18.3762 7.125 18.375 7.125 18.2475 7.125 18.1238 7.125 18 7.125L18 5.625 18.375 5.625C25.2095 5.625 30.75 11.1655 30.75 18Z",
    fill: "#4C39A0",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.02778 0 0 1 523 378)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.cb4fd617b79d017648cc8421aa2b8200.svg";
export { ForwardRef as ReactComponent };